export const TAB_NAMES = {
  CONNECTED_SCORERS: 'Connected Scorers',
  LIVE_DATA_CLIENTS: 'Live Data Clients',
  FIXTURE_ACTION_LATENCY: 'Fixture Action Latency',
  FIXTURE_IMPORT: 'Fixture Import',
  SIMULATION_SCHEDULES: 'Simulation Schedules',
  SIMULATIONS: 'Simulations',
  AVERAGE_LATENCIES: 'Average Latencies',
} as const;
